import { BaseDadosService } from './../../../../../services/base-dados.service';
import { Component, OnInit } from '@angular/core';
import { SubheaderService } from '../../../../../core/services/layout/subheader.service';

@Component({
  selector: 'm-base-dados',
  templateUrl: './base-dados.component.html',
  styleUrls: ['./base-dados.component.scss'],
})
export class BaseDadosComponent implements OnInit {

  modelo: any = {};

  constructor(
    public subheaderService: SubheaderService,
    public baseDadosService: BaseDadosService) {

    this.baseDadosService.getInformacoes()
      .subscribe(modelo => {
        this.modelo = modelo;
      });
  }

  ngOnInit() {

    this.subheaderService.setTitle('Base de Dados');
    this.subheaderService.setBreadcrumbs([
      { title: 'Base de Dados', page: '/pages/configuracoes/base-dados' },
    ]);
  }
}
